import React, {useState} from "react"
import {useFormikContext} from "formik"
import {useTranslation} from "next-i18next"
import Typography from "../reusable/Typography/Typography"

enum Genders {
	Herr = "Herr",
	Frau = "Frau"
}

const GenderButtons = () => {
	const {t} = useTranslation()

	// Context
	const formik = useFormikContext()
	const values = formik.values as any
	const [selectedHerr, setSelectedHerr] = useState(values.gender === Genders.Herr)
	const [selectedFrau, setSelectedFrau] = useState(values.gender === Genders.Frau)

	return (
		<>
			{/* Desktop Buttons */}
			<div className="row mb-3 d-none d-md-flex">
				<Typography variant="bodyLgBold"
					semanticTag="div"
					className="col-12 mb-2">
					{t("Gender")}<span className="text-danger">*</span>
				</Typography>
				<div className={"col-auto"}>
					<button
						onClick={() => {
							formik.setFieldValue("gender", "Frau")
							setSelectedHerr(false)
							setSelectedFrau(true)
						}}
						type={"button"}
						className={`btn px-4  text-start overflow-hidden position-relative ${selectedFrau ? "text-white bg-dark" : "text-dark bg-light"}`}
						style={{borderRadius: "16px"}}
					>
						{t("Frau")}
					</button>
				</div>

				<div className={"col-auto"}>
					<button
						onClick={() => {
							formik.setFieldValue("gender", "Herr")
							setSelectedHerr(true)
							setSelectedFrau(false)
						}}
						type={"button"}
						className={`btn px-4  text-start overflow-hidden position-relative ${selectedHerr ? "text-white bg-dark" : "text-dark bg-light"}`}
						style={{borderRadius: "16px"}}
					>
						{t("Herr")}
					</button>
				</div>
			</div>
			{/* Mobile new design */}
			<div className="row mb-3 d-md-none">
				<Typography variant="bodyLgBold"
					semanticTag="div"
					className="col-12 mb-2">
					{t("Gender")}<span className="text-danger">*</span>
				</Typography>
				<div className={"col-auto"}>
					<button
						onClick={() => {
							formik.setFieldValue("gender", "Frau")
							setSelectedHerr(false)
							setSelectedFrau(true)
						}}
						type={"button"}
						className={`btn px-4  text-start overflow-hidden position-relative ${selectedFrau ? "text-white bg-dark" : "text-dark bg-light"}`}
						style={{borderRadius: "16px"}}
					>
						{t("Frau")}
					</button>
				</div>

				<div className={"col-auto"}>
					<button
						onClick={() => {
							formik.setFieldValue("gender", "Herr")
							setSelectedHerr(true)
							setSelectedFrau(false)
						}}
						type={"button"}
						className={`btn px-4  text-start overflow-hidden position-relative ${selectedHerr ? "text-white bg-dark" : "text-dark bg-light"}`}
						style={{borderRadius: "16px"}}
					>
						{t("Herr")}
					</button>
				</div>
			</div>

		</>
	)
}

export default GenderButtons
